<template>
  <!--
    Redirect shim — single source of truth for the privacy policy lives at
    kiey.com/privacy-policy.html. This route is kept for back-compat with
    emails, old bookmarks, and links inside admin.kiey.com that still use
    `/privacy_policy`. Whenever someone lands here we bounce them to the
    canonical public page so the content matches iOS and Google Play.
  -->
  <v-content class="gb">
    <v-container class="fill-width text-center" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" md="8">
          <v-card class="fill-width card-theme" style="padding: 64px 32px;">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
            <p style="margin-top: 16px; color: #5A6A85;">Redirecting to the Kiey Privacy Policy…</p>
            <p style="margin-top: 8px; font-size: 13px;">
              If you aren't redirected automatically,
              <a href="https://kiey.com/privacy-policy.html">click here</a>.
            </p>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>
<script>
export default {
  name: "privacy_policy_redirect",
  created() {
    window.location.replace("https://kiey.com/privacy-policy.html");
  },
};
</script>
